export enum InitialContact {
  /** @description Rekommendation */
  Recommendation = "Recommendation",
  /** @description Intresseanmälan */
  SelfRegister = "SelfRegister",
  /** @description Skapad av Bonliva */
  CreatedByBonliva = "CreatedByBonliva",
  /** @description Skapad av WCC */
  CreatedByWCC = "CreatedByWCC"
}

export enum SelfRegisterOption {
  /** @description Ej angett */
  SelfRegisterNotSpecified = "SelfRegisterNotSpecified",
  Bemlo = "Bemlo",
  /** @description Bonliva-appen */
  BonlivaApp = "BonlivaApp",
  /** @description Arbetsförmedlingen */
  EmploymentAgency = "EmploymentAgency",
  /** @description Chattfunktionen på hemsidan */
  HomepageChat = "HomepageChat",
  Lead = "Lead",
  LinkedIn = "LinkedIn",
  Newsletter = "Newsletter",
  /** @description Telefon/mail */
  PhoneCall = "PhoneCall",
  /** @description Sökmotor */
  SearchEngine = "SearchEngine",
  /** @description Intresseanmälan via Hemsida */
  SelfRegisterHemsida = "SelfRegisterHemsida",
  /** @description Intresseanmälan via pappersblankett */
  SelfRegisterPaper = "SelfRegisterPaper",
  /** @description Intresseanmälan via telefon */
  SelfRegisterPhone = "SelfRegisterPhone",
  /** @description Sociala medier */
  SocialMedia = "SocialMedia"
}
